import * as React from 'react'

interface Props {
  current: number
  max: number
  limit: number
  className?: string
  style?: React.CSSProperties
  onClick: (page: number) => void
}

const Component: React.FC<Props> = ({ current, max, limit, className, style, onClick }) => {
  const pages = []
  if (max > 0) {
    pages.push(current)
    for (let i = 1; i <= limit; i++) {
      const prev = current - i
      if (prev > 0) {
        pages.unshift(prev)
      }
      const next = current + i
      if (next <= max) {
        pages.push(next)
      }
    }
    const prevButton = current > 1
    const nextButton = current < max
    return (
      <div className={`pagination ${className ?? ''}`} style={style}>
        <button disabled={!prevButton} onClick={() => onClick(current - 1)}>
          &lt;
        </button>
        {pages.map((page, index) => (
          <button className={page === current ? 'selected' : ''} onClick={() => onClick(page)} key={index}>
            {page}
          </button>
        ))}
        <button disabled={!nextButton} onClick={() => onClick(current + 1)}>
          &gt;
        </button>
      </div>
    )
  } else {
    return null
  }
}

export default Component
